"use strict";import{NumberField as e}from"./src/NumberField.js";import{defineElement as m}from"@spectrum-web-components/base/src/define-element.js";m("sp-number-field",e);
//# sourceMappingURL=sp-number-field.js.map
